// SPDX-License-Identifier: AGPL-3.0-or-later
import Channels from '@app/features/channel/state/Channels';
import Emoji from '@app/features/emoji/state/Emoji';
import * as EmojiUtils from '@app/features/expressions/utils/EmojiUtils';
import UserSettings from '@app/features/user/state/UserSettings';
import * as AvatarUtils from '@app/features/user/utils/AvatarUtils';
import {EmojiKind} from '@app/vendor/markdown_parser/types/Enums';
import type {EmojiNode} from '@app/vendor/markdown_parser/types/Nodes';

interface EmojiRenderData {
	url: string | null;
	name: string;
	isAnimated: boolean;
	id?: string;
}
export function getEmojiRenderData(
	emojiNode: EmojiNode,
	guildId?: string,
	disableAnimatedEmoji = false,
): EmojiRenderData {
	const {kind} = emojiNode;
	const emojiName = `:${kind.name}:`;
	if (kind.kind === EmojiKind.Standard) {
		return {
			url: EmojiUtils.getTwemojiURL(kind.codepoints),
			name: emojiName,
			isAnimated: false,
		};
	}
	const {id} = kind;
	const channel = guildId ? Channels.getChannel(guildId) : undefined;
	const disambiguatedEmoji = Emoji.getDisambiguatedEmojiContext(channel?.guildId).getById(id);
	const isAnimated = disambiguatedEmoji?.animated ?? kind.animated;
	const shouldAnimate = isAnimated && !disableAnimatedEmoji && UserSettings.getAnimateEmoji();
	const finalEmojiName = `:${disambiguatedEmoji?.name || kind.name}:`;
	return {
		url: AvatarUtils.getEmojiURL({id, animated: shouldAnimate}),
		name: finalEmojiName,
		isAnimated,
		id,
	};
}
